module.exports = __webpack_public_path__ + "static/img/invitation.92b43e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/integral/invitation.png
// module id = EqVW
// module chunks = 1